import Papa from 'papaparse';
import dayjs from 'dayjs';

// Header for the employee-identifier column shared by every download (Dashboard,
// Results, ...), so a change to the fallback/label logic only has to happen once.
export function idColumnLabel(company, tr) {
    return company?.id_label || tr('local_id');
}

export function downloadCsv(data, fileName) {
    const csv = Papa.unparse(data);
    // BOM UTF-8 para que Excel respete los acentos; no agregamos la línea "sep=,"
    // porque ensucia la primera fila (quien necesite Excel nativo usa el XLSX).
    const file = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}

// Builds a meaningful download file name out of the given parts (e.g. company
// name + section label), appending today's date so repeated exports don't
// collide and the user can tell them apart in their downloads folder.
// Result example: "TalentSense - Marval - Resultados - 2026-06-28.csv".
export function buildDownloadName(parts, extension = 'csv') {
    const sanitize = (s) => String(s ?? '')
        .replace(/[\\/:*?"<>|]/g, '') // drop characters illegal in file names
        .replace(/\s+/g, ' ')
        .trim();
    const segments = ['TalentSense', ...parts]
        .map(sanitize)
        .filter(Boolean);
    segments.push(dayjs().format('YYYY-MM-DD'));
    return `${segments.join(' - ')}.${extension}`;
}
